import { Day } from "date-fns";

export function zip<TFirst, TSecond>(
  leftArray: TFirst[],
  rightArray: TSecond[]
) {
  if (leftArray.length !== rightArray.length) {
    throw new Error("Arrays of variable lengths is not supported");
  }

  type Pair = [TFirst, TSecond];
  let result: Array<Pair> = [];

  for (let i = 0; i < leftArray.length; i++)
    result.push([leftArray[i], rightArray[i]]);

  return result;
}

export function first(arr: any[] | null | undefined) {
  return arr && arr.length > 0 ? arr[0] : undefined;
}

export type Optional<T> = T | undefined | null | false;
export function classNames(...classNames: Optional<string>[]) {
  return { className: classNames.filter((c) => !!c).join(" ") };
}

export type Loadable<T> = T | "loading";

export function addDays(day: Day, addition: number): Day {
  return ((day + addition) % 7) as Day;
}

export function yesterday(day: Day) {
  return addDays(day, -1) as Day;
}

export function tomorrow(day: Day) {
  return addDays(day, 1) as Day;
}

export function readFileAsDataURL(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.addEventListener(
      "load",
      () => {
        if (fileReader.result && typeof fileReader.result === "string") {
          resolve(fileReader.result);
        }
      },
      false
    );
    fileReader.addEventListener("error", reject);
    fileReader.readAsDataURL(file);
  });
}

export function* lazyMap<TKey, TValue, TResult>(
  src: Map<TKey, TValue>,
  fn: (k: TKey, v: TValue) => TResult
): Iterable<TResult> {
  for (const [k, v] of src) {
    yield fn(k, v);
  }
}
